import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormGroup } from '@angular/forms';
import { MCButtonComponent, MCDialogComponent, MCFormFieldWrapperComponent, MCRadioButtonGroup, McInfoComponent, MCAccessibilityLabelDirective } from '@maslul/common-components';
import { InputTextModule } from 'primeng/inputtext';
import { Router } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MCDialog, MC_RESPONSE_STATUS_CODE, MCUtils } from '@maslul/common-services';
import { SelectItem } from 'primeng/api';
import { RequestApprovalTypeDetails, RequestApprovalTypeDetailsStore } from '../../../../../services/store/approval-type-details-store';
import { Subscription } from 'rxjs';
import { SelectedApprovalTypeComponent } from '../../components/approval-type-method/approval-types/selected-approval-type';
import { ApprovalTypeMethodSkeletonComponent } from '../../components/approval-type-method/skeleton/skeleton';
import { ApprovalTypeService } from '../../../../../services/pages/approval-type/approval-type.service';
import { SecondRequest } from '../../../../../models/request-submission-methods/approvalType/secondRequest';
import { ValidationMessageData } from '../../../../../resources/validation-massage';
import { TranslateService } from '@ngx-translate/core';
import { MIHttpService } from '../../../../../services/shared/union-request-http';
import { PageBaseComponent } from '../../../../shared/page-base';
import { FocusOnTabDirective } from '../../../../../services/shared/directives/focus-on-tab';
import { ApprovalTypesService } from '../../../../../services/approval-type/approval-type';


@Component({
    selector: 'mi-approval-type-method',
    imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MCButtonComponent,
        AutoCompleteModule,
        McInfoComponent,
        MCFormFieldWrapperComponent,
        SelectedApprovalTypeComponent,
        ApprovalTypeMethodSkeletonComponent,
        InputTextModule,
        MCRadioButtonGroup,
        FocusOnTabDirective,
        MCDialogComponent,
        MCAccessibilityLabelDirective
    ],
    providers: [],
    templateUrl: './approval-type-method.html',
    styleUrl: './approval-type-method.scss',
    encapsulation: ViewEncapsulation.None
})
export class ApprovalTypeMethodComponent extends PageBaseComponent implements OnInit, OnDestroy {

    genericText: any;
    approvalTypeMethodText: any;
    constructor(
        public override router: Router,
        private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore,
        private approvalTypeService: ApprovalTypeService,
        private translateService: TranslateService,
        private httpService: MIHttpService,
        private approvalTypesService: ApprovalTypesService,

        //private fb: FormBuilder
    ) {
        super(router);
        // this.myForm = this.fb.group({
        //     gender: new FormControl(null) // או new FormControl('male')
        // });
    }
    //myForm: FormGroup;
    //public selectedGender: string | null = null;

    chooseApprovalTypeLable = "בחירת סוג אישור";
    public customErrorMessages = ValidationMessageData.customErrorMessages
    approvalMainTypeName: string = "";
    subscribtion: Subscription = new Subscription();
    approvalTypeForm!: FormGroup;
    approvalTypes: SelectItem[] = [];
    typeCode: string = "";
    secondRequest: string = "";
    approvalTypeInfo: string = "";
    personalImportApTypes: SecondRequest[] = [];
    endedLoading: boolean = false;
    approvalType: number | undefined;
    dialogProperties: MCDialog = new MCDialog();

    ngOnInit(): void {
        this.init();
        this.initText();


    }

    initText() {
        this.subscribtion.add(this.translateService.stream('generic').subscribe(translation => {
            this.genericText = translation;
        }));

        this.subscribtion.add(this.translateService.stream('approvalTypeMethod').subscribe(translation => {
            this.approvalTypeMethodText = translation;
        }));
    }


    init() {
        this.initApprovalTypes();

    }

    initApprovalTypes() {
        this.personalImportApTypes = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypes;
        this.approvalMainTypeName = this.requestApprovalTypeDetailsStore.getSnapshot().approvalMainTypeName;
        const existApprovalType = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId;
        this.approvalTypes = this.personalImportApTypes.map(item => ({ value: item.apTypeId, label: item.miApTypeName || item.apTypeName }));
        const approvalTypeId = existApprovalType || this.approvalTypes[0]?.value;
        this.approvalType = approvalTypeId;
        this.approvalTypeSelected(approvalTypeId);
    }


    setApprovalTypeDetails(approvalTypeDetails: SecondRequest) {
        const secondRequest: number = isNaN(parseInt(approvalTypeDetails.secondRequest))
            ? 0 : parseInt(approvalTypeDetails.secondRequest);
        this.requestApprovalTypeDetailsStore.setSecondRequest(secondRequest?.toString());

        const approvalTypeId: number = isNaN(parseInt(approvalTypeDetails.apTypeId))
            ? 0 : parseInt(approvalTypeDetails.apTypeId);
        this.requestApprovalTypeDetailsStore.setApprovalTypeId(approvalTypeId?.toString());
        this.requestApprovalTypeDetailsStore.setApprovalTypeName(approvalTypeDetails?.apTypeName);
        this.requestApprovalTypeDetailsStore.setIs4DigitsCustomItem(approvalTypeDetails.is4DigitsCustomItem);
    }

    setApprovalTypeInfo() {
        const requestApprovalTypeDetails: RequestApprovalTypeDetails = this.requestApprovalTypeDetailsStore.getSnapshot();
        const approvalTypeKey = MCUtils.padZero(requestApprovalTypeDetails.authorityId) +
            MCUtils.padZero(requestApprovalTypeDetails.typeCode) +
            MCUtils.padZero(requestApprovalTypeDetails.secondRequest);
        this.approvalTypeService.getInfoByKey(approvalTypeKey).subscribe((info: string) => {
            this.approvalTypeInfo = info;
            this.endedLoading = true;
        });
    }

    onTryChange(approvalType: any) {
        this.approvalTypeSelected(approvalType);
    }

    approvalTypeChange(approvalType: any) {

        if (this.approvalTypesService.isChangeAprovalType(approvalType.apTypeId)) {
            this.approvalTypesService.showDialogOnApprovalChange(this.dialogProperties, this.approvalTypeMethodText.dialogAutorityChanged);
            this.approvalTypeSelected(approvalType);
        }
        else {
            this.approvalTypeSelected(approvalType);

        }
    }

    initDialog() {
        this.dialogProperties.breakpoints = {
            '960px': '75vw', // ברוחב 960px ומטה, רוחב הדיאלוג יהיה 75vw
            '640px': '80vw' // ברוחב 640px ומטה, רוחב הדיאלוג יהיה 80
        };
        this.dialogProperties.id = 'mi-request-submission-methods-dialog';

    }
    clearStoreOnApprovalChange() {
        this.dialogProperties.visible = true
    }

    approvalTypeSelected(approvalType: string, _save: boolean = true) {
        const approvalTypeDetails: SecondRequest | undefined = this.personalImportApTypes.find(x => x.apTypeId == approvalType);
        if (approvalTypeDetails) {
            if (this.approvalTypesService.isChangeAprovalType(approvalTypeDetails.apTypeId)) {
                this.approvalTypesService.clearStoreOnApprovalChange();
            }
            this.setApprovalTypeDetails(approvalTypeDetails);
            this.setApprovalTypeInfo();
            this.getApprovalTabs();

        }
    }

    getApprovalTabs() {
        this.endedLoading = false;
        const approvalTypeId = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId

        this.subscribtion.add(this.httpService.GetApprovalTabs([parseInt(approvalTypeId)]).subscribe((res) => {
            if (res.code === MC_RESPONSE_STATUS_CODE.SUCCESS) {

                this.requestApprovalTypeDetailsStore.setApprovalTabs(res.data);
                this.endedLoading = true;
            }

        }))
    }

    getApprovalTypeSelectedName(): string {
        //const selectedApprovalTypeId = this.getFormControl("approvalType").value;
        return this.personalImportApTypes.find(x => x.apTypeId == this.approvalType?.toString())?.miApTypeName
            || this.personalImportApTypes.find(x => x.apTypeId == this.approvalType?.toString())?.apTypeName
            || "";

    }

    showApprovalTypeInfo = (): boolean => this.approvalTypeInfo?.length > 0;

    next() {
        this.navigation('applicant-details');
    }

    back() {
        this.navigation('request-submission-methods');
    }

    haseMoreThanOneApprovalType(): boolean {
        return (this.approvalTypes.length || 0) > 1;
    }

    ngOnDestroy(): void {
        this.subscribtion.unsubscribe();
    }
}
